import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Driver } from '@commons/models/domain/Driver';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { VehicleTachoSlot } from '@commons/models/domain/VehicleTacho';
import { MappingService } from '@commons/services/mapping/mapping.service';
import { VehicleService } from '@commons/services/vehicle/vehicle.service';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list-vehicle-tacho-item',
  templateUrl: './list-vehicle-tacho-item.component.html',
  styleUrls: ['./list-vehicle-tacho-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListVehicleTachoItemComponent implements OnInit, OnDestroy {
  @Input() isSelected?: boolean;
  @Input() hasBlockerReadPermissionUser: boolean;

  @Input() set vehicle(value: Vehicle) {
    this.vehicleValue = new Vehicle(value, this.translate);
    this.checkBlockerStatus();

    if (value.Tacho) {
      this.setTachoData();
    }
  }

  public isLoading: boolean = true;
  public isNoDriver: boolean = false;
  public vehicleValue: Vehicle;
  public activeSlotData!: VehicleTachoSlot;
  public currentStateTacho?: number;
  public driver?: Driver;
  public isBlocked?: boolean;

  private readonly ComponentSubsc: Subscription = new Subscription();

  public get elementId(): number {
    return this.vehicleValue?.Id;
  }

  constructor(
    private vehicleService: VehicleService,
    private changeDetRef: ChangeDetectorRef,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.checkBlockerStatus();
  }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  private setTachoData(): void {
    if (this.vehicleValue.Tacho) {
      const ifSlot1 = this.vehicleValue.Tacho.S1 && this.vehicleValue.Tacho.S1.Id;
      if (ifSlot1) {
        this.setActiveSlot(this.vehicleValue.Tacho.S1 as VehicleTachoSlot);
        return;
      }

      const ifSlot2 = this.vehicleValue.Tacho.S2 && this.vehicleValue.Tacho.S2.Id;
      if (ifSlot2) {
        this.setActiveSlot(this.vehicleValue.Tacho.S2 as VehicleTachoSlot);
        return;
      }

      this.isNoDriver = true;
    }
    this.isLoading = false;
    this.changeDetRef.markForCheck();
  }

  private setActiveSlot(slotData: VehicleTachoSlot): void {
    this.currentStateTacho = MappingService.convertTachoStatus(slotData.St);
    this.activeSlotData = {...(slotData || {})};

    if (slotData?.Id) {
      this.getDriverData();
      return;
    }
    this.whenNoDriverData();
  }

  private getDriverData(): void {
    const sub = this.vehicleService.getCurrentDriver$(this.activeSlotData.Id).subscribe(driver => {
      if (driver) {
        this.isDriver(driver);
        return;
      }
      this.whenNoDriverData();
    });
    this.ComponentSubsc.add(sub);
  }

  private whenNoDriverData(): void {
    this.isLoading = false;
    this.isNoDriver = true;
    this.changeDetRef.markForCheck();
  }

  private isDriver(data: Driver): void {
    this.driver = {...data};
    this.isNoDriver = false;
    this.isLoading = false;
    this.changeDetRef.markForCheck();
  }

  private checkBlockerStatus(): void {
    if (this.hasBlockerReadPermissionUser && (this.vehicleValue?.blockerParametrId || this.vehicleValue?.blockerParametrIdOut2)) {
      const control = this.vehicleValue.blockerParametrId ? this.vehicleValue.ControlIndicators?.find(item => item.Id === this.vehicleValue.blockerParametrId) : null;
      const controlOut2 = this.vehicleValue.blockerParametrIdOut2 ? this.vehicleValue.ControlIndicators?.find(item => item.Id === this.vehicleValue.blockerParametrIdOut2) : null;
      this.isBlocked = control?.LV?.V || controlOut2?.LV?.V;
    }
  }

}
